

import './profile.component.js';
import './profile.controller.js';
import './_profile.styles.scss';
import './_shop-hours.scss';

angular
.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  .state('profile', {
    url: '/{username}',
    abstract: true,
    views: {
      '@': {
        component: 'inkProfile'
      }
    },
    resolve: {
      $title: function(provider, _) {
        if (!_.isUndefined(provider)) {
          return _.isUndefined(provider.name) ?
          provider.first_name + ' ' + provider.last_name : provider.name;
        }
        return 'Not found';
      },
      provider: function($stateParams, $q, Collector, Shop, _) {
        let results = {
          usernames: []
        };
        let formattedUsername = ($stateParams.username).toLowerCase();
        if (formattedUsername !== '' &&
        formattedUsername.match(/^[a-z0-9]*$/)) {
          return $q.all([
            Collector.getCollectors(formattedUsername),
            Shop.getShops(formattedUsername)
          ]).then(function(usernames) {
            results.usernames = _.merge(usernames[0], usernames[1]);
            return results.usernames[0];
          });
        }
        return $q(function(resolve, reject) {
          resolve(results.usernames[0]);
        });
      }
    },
    params: {
      username: {dynamic: true}
    },
    onEnter: function(Events) {
      Events.secondaryNavActive = true;
    },
    onExit: function(Events) {
      Events.secondaryNavActive = false;
    }
  })

  // This is the default state based on the blank URL value.
  .state('profile.appointment', {
    url: '',
    views: {
      profile: {
        component: 'inkAddProject'
      }
    }
  });
});



// WEBPACK FOOTER //
// ./components/profile/index.js